import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SkipSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SkipSVG;
